import React from 'react';
import ReactDOM from 'react-dom';
import deserialize from '../utils/deserialize';
import './membership.css';
import PfLinkBridgePage from '../containers/PfLinkBridgePage';

const serialized = document.getElementById('initial-data').getAttribute('data-json');
const preloadedState = deserialize(eval('(' + serialized + ')'));

const device = preloadedState.get('device');
const url = preloadedState.get('url');
const error = preloadedState.get('error');

ReactDOM.render(
  <PfLinkBridgePage
    device={device}
    url={url}
    error={error}
  >
  </PfLinkBridgePage>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/membership/pflink.js